import "./App.css";
import { BrowserRouter as Router, Routes, Route, Navigate, useNavigate, } from "react-router-dom";
import Home2024 from "./Pages/Home/Home2024";
// import Login from "./Pages/Login/Login";
// import Signup from "./Pages/Signup/Signup";
// import ForgotPass from "./Pages/ForgotPass/ForgotPass";
import { useEffect, useState } from "react";
// import Settings from "./User/Settings/Settings";
// import Profile from "./User/Profile/Profile";
import PublicLayout from "./Layouts/PublicLayout";
// import UserLayout from "./Layouts/UserLayout";
import ContactUs from "./Pages/ContactUs/ContactUs";
// import PrivacyPolicy from "./Pages/PrivacyPolicy/PrivacyPolicy";
// import TermsandConditions from "./Pages/TermsandConditions/TermsandConditions";
import { getAdminRoutes, getFinalRoutes, getToken } from "./Helper/Token";
// import Dashboard from "./User/Dashboard/Dashboard";
// import Orders from "./User/Orders/Orders";
// import RefundAndCancellation from "./Pages/RefundAndCancellation/RefundAndCancellation";
// import BuyNow from "./Pages/BuyNow/BuyNow";
// import Checkout from "./Pages/Checkout/Checkout";
// import ViewOrder from "./User/ViewOrder/ViewOrder";
// import CheckoutLayout from "./Layouts/CheckoutLayout";
import About from "./Pages/About/About";
import Gallery from "./Pages/Gallery/Gallery";
import CommingSoon from "./Pages/CommingSoon/CommingSoon";
import Error from "./Pages/Error/Error";
import axios from "axios";
import { getWebMaintenance } from "./Api";
import Maintenance from "./Pages/Maintenance/Maintenance";
// import ThankYou from "./Components/Thankyou/ThankYou";
// import PaymentFailed from "./Components/PaymentFailed/PaymentFailed";
// import element from "./Images/Mandli2024/desktopBglayer.svg"
// import LocationQR from "./Pages/LocationQR";


function App() {
  const routesConfig = [
    // { path: '/', element: <CommingSoon /> },
    { path: '/', element: <PublicLayout page={<Home2024 />} /> },
    // { path: '/home2', element: <PublicLayout page={<Home2024 />} /> },
    { path: '/about', element: <PublicLayout page={<About />} /> },
    { path: '/gallery', element: <PublicLayout page={<Gallery />} /> },
    // { path: '/orderstatus', element: <CheckoutLayout page={<ThankYou />} /> },
    // { path: '/res', element: <LocationQR eventLabel="Residential QR Scan" /> },
    // { path: '/am', element: <LocationQR eventLabel="Ahmedabad Mirror QR Scan" /> },
    // { path: '/sam', element: <LocationQR eventLabel="Standee At Mocha QR Scan" /> },
    // User routes
    // { path: '/dashboard', element: <UserLayout page={<Dashboard />} /> },
    // { path: '/orders', element: <UserLayout page={<Orders />} /> },
    // { path: '/orders/vieworder/:id', element: <UserLayout page={<ViewOrder />} /> },
    // { path: '/profile', element: <UserLayout page={<Profile />} /> },
    // { path: '/profile/setting', element: <UserLayout page={<Settings />} /> },
    // Public routes
    // { path: '/buy-now', element: <PublicLayout page={<BuyNow />} /> },
    // { path: '/checkout', element: <Checkout /> },
    // { path: '/privacy-policy', element: <PublicLayout page={<PrivacyPolicy />} /> },
    // { path: '/terms-and-conditions', element: <PublicLayout page={<TermsandConditions />} /> },
    // { path: '/refund-and-cancellation', element: <PublicLayout page={<RefundAndCancellation />} /> },
    { path: '/support', element: <PublicLayout page={<ContactUs />} /> },
    // { path: '/login', element: <Login /> },
    // { path: '/signup', element: <Signup /> },
    // { path: '/forgotpassword', element: <ForgotPass /> },
  ];

  const [loading, setLoading] = useState(false);

  useEffect(() => {
    window.addEventListener("load", () => {
      setLoading(false);
    });
  }, []);

  const [isLogin, setIsLogin] = useState(false)

  useEffect(() => {
    if (localStorage.getItem("token") != null) {
      setIsLogin(true)
    } else if (sessionStorage.getItem('token') != null) {
      setIsLogin(true)
    } else {
      setIsLogin(false)
    }
  }, [localStorage, sessionStorage])

  let token = getToken();


  // Under Maintenance
  const [isMaintenance, setisMaintenance] = useState(false)
  const fetchMaintenance = () => {
    axios.get(getWebMaintenance)
      .then((res) => {
        res.data.result.docs.map((ele) => {
          if (ele.flag === 1) {
            setisMaintenance(true)
          }
        })
      })
  }
  useEffect(() => {
    fetchMaintenance()
  }, [])

  return (
    <div className="App">
      {loading ? (
        <div className="preloader">
          <div className="loader"></div>
        </div>
      ) : (
        <div className="routes stickyImgAdded">
          <Router>
            <Routes>
              {/* <Route path="/" element={<CommingSoon />} /> */}
              <Route path="*" element={<Error />} />
              {
                isMaintenance ?
                  <>
                    <Route path="/" element={<Maintenance />} />
                    <Route path="*" element={<Navigate to={'/'} />} />
                  </>
                  :
                  routesConfig.map((route, index) => (
                    <Route key={index} path={route.path} element={route.element} />
                  ))
              }
            </Routes>
          </Router>
        </div>
      )}
    </div>
  );
}

export default App;